import axios from 'axios';
import { handleServerErrors, persistentHandler } from '../../../registration/util/error';
import { getConfig } from '../../../registration/util/config';
import { PATH } from './ClientParamChangeVerification';

function handleCTErrors(form, onClose) {
    return handleServerErrors(form, {
        codeHandlers: {
            VERIFICATION_FAILED_WRONG_CODE: persistentHandler(PATH.CODE, 'validation.code.wrong'),
            VERIFICATION_TOO_MANY_FAILED: persistentHandler(PATH.CODE, 'validation.code.too-many-failed')
        },
        uiWrapper: a => a,
        finalHandler: error => {
            if (onClose) {
                onClose();
            }
            getConfig().open('ERROR', { status: error.response.status, code: error.response.data.code });
        }
    });
}

export const startAuthorizeContact = (forcedActionCrmType, form, onClose) =>
    axios
        .post('/api/client-params/authorize-contact', JSON.stringify(forcedActionCrmType), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .catch(handleCTErrors(form, onClose));

export const verifyContact = (verifyForcedActionCrm, form, onDone) =>
    axios
        .post('/api/client-params/authorize-contact/verify', verifyForcedActionCrm)
        .then(onDone)
        .catch(handleCTErrors(form));
